// Brand constants. Placeholder contact details - replace before launch.
export const SITE = {
  name: 'Boss Contractor Agency',
  shortName: 'Boss',
  domain: 'bosscontractoragency.com',
  url: 'https://bosscontractoragency.com',
  tagline: 'Marketing that books jobs for contractors',
  description:
    'Websites, local SEO, Google Ads and review systems built for roofers, HVAC, plumbers, electricians and remodelers. More booked jobs, less chasing leads.',
  phone: '(555) 010-2030',
  phoneHref: 'tel:+15550102030',
  email: 'hello@bosscontractoragency.com',
  hours: 'Monday to Friday, 8am to 6pm ET',
  location: 'Serving contractors across the U.S.',
}

export const NAV = [
  { to: '/services', label: 'Services' },
  { to: '/results', label: 'Results' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
]
